var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.5C0 11.636 3.364 15 7.5 15S15 11.636 15 7.5 11.636 0 7.5 0 0 3.364 0 7.5zm1.25 0A6.257 6.257 0 017.5 1.25a6.258 6.258 0 016.25 6.25 6.258 6.258 0 01-6.25 6.25A6.258 6.258 0 011.25 7.5z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 20c-.16 0-.32-.062-.442-.184l-6.818-6.819a.624.624 0 11.883-.883l6.819 6.818a.624.624 0 01-.442 1.067z",
    fill: "#1C1C1C"
  })));
}
export default SvgSearchIcon;